import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    reduxForm,
    Field,
    FieldArray,
    getFormValues,
    change
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';

import { setModoSaida } from './brindeActions';

const renderItens = ({
    fields,
    brindes,
    estoque,
    readOnly
}) => (
    <div style={{
        width: 'calc(100% - 30px)',
        margin: '8px 15px 12px',
        padding: '16px 16px 6px',
        border: '1px solid #d6dee8',
        borderRadius: 12,
        background: '#ffffff'
    }}>
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12
        }}>
            <strong style={{ color: '#062042', fontSize: 17 }}>
                <i
                    className='fas fa-gift'
                    style={{ marginRight: 8 }}
                />
                Brindes entregues
            </strong>

            {!readOnly &&
                <button
                    type='button'
                    className='btn btn-success'
                    onClick={() => fields.push({
                        id_produto: null,
                        quantidade: 1
                    })}
                >
                    <i
                        className='fas fa-plus'
                        style={{ marginRight: 7 }}
                    />
                    Adicionar brinde
                </button>}
        </div>

        {fields.map((item, index) => {
            const registro = fields.get(index) || {};
            const saldo = (estoque || []).find(
                saldoItem =>
                    Number(saldoItem.id_produto) ===
                    Number(registro.id_produto)
            );

            return (
                <div
                    key={item}
                    style={{
                        padding: '12px 12px 0',
                        marginBottom: 10,
                        border: '1px solid #dce3eb',
                        borderRadius: 9,
                        background: '#f8fafc'
                    }}
                >
                    <Row>
                        <Field
                            name={`${item}.id_produto`}
                            component={Select}
                            options={brindes}
                            label={`Brinde ${index + 1} *`}
                            cols='12 7 6 6'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                        <Field
                            name={`${item}.quantidade`}
                            component={LabelAndInputNumber}
                            label='Quantidade *'
                            casas={0}
                            cols='9 3 3 3'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                        {!readOnly &&
                            <Grid cols='3 2 1 1'>
                                <button
                                    type='button'
                                    className='btn btn-danger'
                                    title='Remover brinde'
                                    disabled={fields.length === 1}
                                    onClick={() => fields.remove(index)}
                                    style={{ marginTop: 29 }}
                                >
                                    <i className='fas fa-trash-alt' />
                                </button>
                            </Grid>}
                    </Row>

                    {saldo &&
                        <div style={{
                            marginTop: -8,
                            marginBottom: 10,
                            color: '#475569',
                            fontSize: 13
                        }}>
                            Disponível em estoque: {' '}
                            <strong>
                                {FormatUtils.formatarValorTela(
                                    saldo.quantidade_estoque,
                                    0
                                )}{' '}
                                {saldo.sigla_unidade_medida}
                            </strong>
                        </div>}
                </div>
            );
        })}
    </div>
);

let BrindeSaidaForm = props => {
    const formulario = props.formulario || {};
    const readOnly = Boolean(props.excluir);

    const alterarCliente = idCliente => {
        const cliente = (props.clientes || []).find(
            item => Number(item.id) === Number(idCliente)
        );

        props.alterarCampo('id_cliente', idCliente);
        props.alterarCampo(
            'id_usuario_representante',
            cliente ? cliente.id_usuario_representante : null
        );
    };

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Row>
                        <Field
                            name='datahora_saida'
                            component={LabelAndInput}
                            type='datetime-local'
                            label='Data e hora *'
                            cols='12 4 3 3'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                        <Field
                            name='id_cliente'
                            component={Select}
                            options={props.clientes}
                            label='Cliente *'
                            cols='12 4 4 4'
                            readOnly={readOnly ? 'readOnly' : ''}
                            value={formulario.id_cliente}
                            onChange={alterarCliente}
                        />
                        <Field
                            name='id_usuario_representante'
                            component={Select}
                            options={props.representantes}
                            label='Representante *'
                            cols='12 4 4 4'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                    </Row>
                    <Row>
                        <FieldArray
                            name='itens'
                            component={renderItens}
                            brindes={props.brindes}
                            estoque={props.estoque}
                            readOnly={readOnly}
                        />
                    </Row>
                    <Row>
                        <Field
                            name='observacao'
                            component={LabelAndTextarea}
                            label='Observação'
                            placeholder='Informe, se necessário'
                            rows={3}
                            cols='12 12 12 12'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                    </Row>
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoSaida('lista')}
                            />
                        </Grid>
                        <Grid cols='6 6 4 3'>
                            {props.excluir
                                ? <Button
                                    text='Excluir'
                                    submit
                                    type='danger'
                                    icon='fa fa-trash'
                                />
                                : <Button
                                    text='Salvar'
                                    submit
                                    type='success'
                                    icon='fa fa-check'
                                />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

BrindeSaidaForm = reduxForm({
    form: 'brindeSaidaForm',
    destroyOnUnmount: false
})(BrindeSaidaForm);

const mapStateToProps = state => ({
    formulario: getFormValues('brindeSaidaForm')(state),
    clientes: state.brinde.clientes,
    representantes: state.brinde.representantes,
    brindes: state.brinde.brindes,
    estoque: state.brinde.estoque
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoSaida,
    alterarCampo: (campo, valor) =>
        change('brindeSaidaForm', campo, valor)
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BrindeSaidaForm);
